import { create } from 'zustand';
import { createParamsByActivities } from '../../creators/createParamsByActivities';
import { getImagesInSearch } from '../../api/Images/getImagesInSearch';
import { TAttractionsStore } from './domain';
import { DEFAULT_ATTRACTIONS_STATE } from './state';
import { getPrices } from '@/service/api/Prices/getPrices';

//const CHUNK_SIZE = 10;

export const useAttractionsStore = create<TAttractionsStore>((set, get) => ({
    ...DEFAULT_ATTRACTIONS_STATE,
    initAvailability: async (newList, ids, query, partnerSlug) => {
        if (ids === get().activityIds) {
            return;
        }

        const firstActivities = newList; //.slice(0, CHUNK_SIZE);

        set(
            (state) => ({
                ...state,
                fullList: newList,
                showList: firstActivities,
                hasMore: newList.length !== firstActivities.length,
                activityIds: ids,
            }),
            true
        );

        const [activity_ids, params] = createParamsByActivities(firstActivities, query);

        const [newImages, prices] = await Promise.all([
            getImagesInSearch(activity_ids),
            getPrices(partnerSlug, activity_ids),
        ]);

        set((state) => ({
            ...state,
            images: newImages,
            prices: prices || {},
            params: params,
        }));
    },
    handleTripViewChange: (view) => {
        set({
            tripView: view,
        });
    },
    updateListToShow: (newList) => {
        set({
            showList: newList,
        });
    },
}));
